import { match, P } from 'ts-pattern'

import type { VersionState, VersionStatus } from 'features/versions/types'

export const getDefaultVersionState = (status: VersionStatus) => {
  return match<VersionStatus, VersionState>(status)
    .with('downloading', 'unpacking', 'installing', (_versionStatus) => ({ status: _versionStatus, progress: 0 }))
    .with(
      P.union('notInstalled', 'done', 'installed', 'partiallyInstalled', 'error', 'updateAvailable', 'canceling'),
      (_versionStatus: 'done' | 'installed' | 'notInstalled' | 'partiallyInstalled' | 'canceling') => ({
        status: _versionStatus,
      }),
    )
    .exhaustive()
}
